import React from "react";
import { LucideIcon } from "lucide-react";

interface InputProps {
  id: string;
  name: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  error?: string;
  icon?: LucideIcon;
  rightIcon?: React.ReactNode;
}

const Input: React.FC<InputProps> = ({
  id,
  name,
  type,
  value,
  onChange,
  placeholder,
  error,
  icon: Icon,
  rightIcon,
}) => {
  return (
    <div>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {name === "email" ? "Email" : "Mật khẩu"}
      </label>
      <div className="relative">
        {Icon && (
          <Icon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        )}
        <input
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          className={`block w-full py-2 border rounded-md focus:ring-1 focus:ring-[#0087C1] focus:border-[#0087C1] text-sm ${
            Icon ? "pl-10" : "px-3"
          } ${rightIcon ? "pr-10" : "pr-4"} ${
            error ? "border-red-300" : "border-gray-300"
          }`}
          placeholder={placeholder}
        />
        {rightIcon && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            {rightIcon}
          </div>
        )}
      </div>
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default Input;
